import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import VendorApplicationInit from '../../Components/VendorApplicationInit/VendorApplicationInit';
import { vendorSelector } from '../Admin/selectors';
import adminActions from '../Admin/actions';
import appActions from '../App/actions';

const mapStateToProps = (state) => ({
  vendors: vendorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch admin actions
 */
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(appActions.logout()),
  fetchVendors: (search) => dispatch(adminActions.fetchVendors(search)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorApplicationInit),
);
